<template>
    <div class="section-review"
         :class="{
         'bg-color' : bgColor,
         'mini-rev' : typesItem === 'mini'
         }" >
        <div class="container">
            <div class="row justify-content-center" v-if="'mini' !== typesItem">
                <div class="title">
                    <h2 class="h1 p-title p-black p-center mb-0 relawayBold">User reviews</h2>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-11">
                    <carousel
                            :responsive="getType()"
                            :autoplay="true"
                            :dots="true"
                            :margin="30"
                            :loop="true"
                    >

                        <div class="review-item">
                            <div class="title-row">
                                <div class="img">
                                    <img src="/img/image.png" alt="">
                                </div>
                                <div class="name">
                                    <p class="max p-dgrey relawaySM  mb-0" >
                                        Peter Nordström
                                    </p>
                                </div>
                                <div class="rating">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star empty-star"></div>
                                </div>
                            </div>
                            <div class="content">
                                <p class="min p-dgrey">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
                                    incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
                                    laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit
                                    esse cillum </p>
                            </div>
                            <div class="saved">
                                <p class="p-blue min-med  p-bold">Saved 1200 kr/year by comparing</p>
                            </div>
                            <div class="verify">
                                <p class="p-green2 min">Verifierad köpare <img src="/img/icon/submit.svg" alt=""></p>
                            </div>

                        </div>
                        <div class="review-item">
                            <div class="title-row">

                                <div class="name">
                                    <p class="max p-dgrey relawaySM  mb-0">
                                        Peter Nordström
                                    </p>
                                </div>
                                <div class="rating">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star empty-star"></div>
                                </div>
                            </div>
                            <div class="content">
                                <p class="min p-dgrey">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                                    laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis
                                    et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit
                                    aspernatur aut odit aut f</p>
                            </div>
                            <div class="saved">
                                <p class="p-blue min-med p-bold">Saved 1200 kr/year by comparing</p>
                            </div>

                            <div class="verify">
                                <p class="p-green2 min">Verifierad köpare <img src="/img/icon/submit.svg" alt=""></p>
                            </div>

                        </div>
                        <div class="review-item">
                            <div class="title-row">
                                <div class="img">
                                    <img src="/img/image.png" alt="">
                                </div>
                                <div class="name">
                                    <p class="max p-dgrey relawaySM  mb-0">
                                       Peter Nordström
                                    </p>
                                </div>
                                <div class="rating">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star empty-star"></div>
                                </div>
                            </div>
                            <div class="content">
                                <p class="min p-dgrey">But I must explain to you how all this mistaken idea of denouncing pleasure
                                    and praising pain was born and I will give you a complete account of the system,
                                    and expound the actual teachings of the great explorer of the truth, the master-builder of
                                    human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure,
                                    but because those who do not know how to pursue pleasure rationally encounter consequences
                                    that are extremely painful. Nor again is there anyone who loves or pursues or desires to obtain pain
                                    of itself, because it is p</p>
                            </div>
                            <div class="saved">
                                <p class="p-blue min-med  p-bold">Saved 1200 kr/year by comparing</p>
                            </div>
                            <div class="verify">
                                <p class="p-green2 min">Verifierad köpare <img src="/img/icon/submit.svg" alt=""></p>
                            </div>

                        </div>
                        <div class="review-item">
                            <div class="title-row">

                                <div class="name">
                                    <p class="max p-dgrey  mb-0">
                                        <b>Peter Nordström</b>
                                    </p>
                                </div>
                                <div class="rating">
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star"></div>
                                    <div class="star empty-star"></div>
                                </div>
                            </div>
                            <div class="content">
                                <p class="min p-dgrey">Fakturabeloppet var ungefär hälften
                                    av vad jag förväntat mig. Positiv överraskning!!
                                    Jag är jättenöjd med servicen och leveransen.</p>
                            </div>
                            <div class="saved">
                                <p class="p-blue min-med  p-bold">Saved 1200 kr/year by comparing</p>
                            </div>
                            <div class="verify">
                                <p class="p-green2 min mb-0">Verifierad köpare <img src="/img/icon/submit.svg" alt=""></p>
                            </div>

                        </div>

                    </carousel>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import carousel from 'vue-owl-carousel'

    export default {
        name: "Review",
        components: {
            carousel,
        },
        props: ["bgColor", "typesItem"],
        methods: {
            getType() {
                if (this.typesItem === 'mini') {
                    return {0: {items: 1, nav: false}}
                } else {
                    return {
                        0: {items: 1, nav: false}, 800: {items: 2, nav: false}
                    }
                }
            }
        }
    }
</script>
